module.exports = __webpack_public_path__ + "static/img/公司3.a09dd70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司3.jpg
// module id = Brxj
// module chunks = 1